import { combineReducers } from '@reduxjs/toolkit';

import orderReducer from './orderSlice';

const ordersProfileReducer = combineReducers({
    order: orderReducer,
});

export default ordersProfileReducer;
